import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthenticationService } from '@app/auth';
import { TabManagerService } from '../services/tab-manager.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private shouldModifyHeaders = false;
  private excludedUrls = ['https://pgway-qa.nrsplus.com', 'https://pgway.nrsplus.com', 'https://compass-836110638.catalystserverless.com'];
  constructor(private authService: AuthenticationService, private tabManagerService: TabManagerService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isExcludedUrl = this.excludedUrls.some((url) => request.url.startsWith(url));
    console.log("isExcludedUrl", isExcludedUrl, request.url);
    if (isExcludedUrl) {
      return next.handle(request);
    }
    request = this.addnoCache(request);
    const currentUser = this.authService.currentUserValue;
    if (currentUser && currentUser.token) {
      request = this.addToken(request, currentUser.token);
    }
    let modifiedReq = this.shouldModifyHeaders
      ? request.clone({
          headers: request.headers.delete('Authorization'),
        })
      : request;

      return next.handle(modifiedReq).pipe(
        catchError((error) => {
          if (error instanceof HttpErrorResponse && error.status == 401 && error.error.message == 'Token Expired') {
            this.shouldModifyHeaders = true;
            return this.handle401Error(modifiedReq, next);
          } else if (
            error instanceof HttpErrorResponse &&
            error.status == 401 &&
            error.error.detail == 'Refresh Token Expired'
          ) {
            this.authService.logOut();
            return throwError(() => 'Refresh Token Expired');
          } else if (
            error instanceof HttpErrorResponse &&
            error.status == 401 &&
            error.error.message == 'Invalid token for the Session'
          ) {
            this.authService.logOut(['/','login']);
            this.tabManagerService.tabChangeEvent.next({logout:true, nextUrl: "/login", sessionExpired: true, message: 'Session expired.'});
            return throwError(() => 'Session Token Expired');
          } else {
            this.shouldModifyHeaders = false;
            return throwError(() => error);
          }
        }),
    );
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token,
      },
    });
  }

  private addnoCache(request: HttpRequest<any>) {
    return request.clone({
      setHeaders: {
        'Cache-Control': 'no-store',
        Pragma: 'no-cache',
      },
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.getrefreshToken().pipe(
        switchMap((user: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(user.token);
          this.shouldModifyHeaders = false;
          return next.handle(this.addToken(request, user.token));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          //this.authService.logOut();
          return throwError(() => err);
        }),
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((token) => next.handle(this.addToken(request, token))),
      );
    }
  }
}
